import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_EN.json';
import audios from './ASTROLOGY_AUDIOS_EN.json';

export const ASTROLOGY_DATA_EN: ServiceData = {
  articles,
  audios,
};
